export default "__VITE_ASSET__B$8NZfnC__"